export const multilangMessages = {
  projectName: "PROJECT NAME",
  projectId: "PROJECT ID",
  projectIdEditDisabledFinished: "Project ID cannot be edited after any language has been completed",
  uploaded: "UPLOADED",
  delivered: "DELIVERED",
  dueDate: "DUE DATE",
  languages: "LANGUAGES",
  genre: "GENRE",
  skillset: "SKILLSET NODE",
  price: "PRICE",
  files: "FILES",
  delivery: "DELIVERY",
  language: "LANGUAGE",
  stage: "STAGE",
  status: "STATUS",
  action: "ACTION",
  completed: "COMPLETED",
  communities: "KNOWLEDGE BASES",
  download: "Download",
  downloadAll: "Download all files",
  reopen: "Reopen",
  instructions: "Instructions",
  inProgress: "In progress",
  canceled: "Canceled",
  wordCounts: "WORD COUNTS",
  newAssets: "New assets:",
  repeatedAssets: "Repeated assets:",
  recycledAssets: "Recycled assets:",
  total: "Total:",
  words: "WORDS",
  stage_FILE_PREPARATION: "File Preparation",
  stage_FILE_PARSING: "File Parsing",
  stage_OCR: "OCR",
  stage_ANONYMIZATION: "Anonymization",
  stage_RECYCLING_ONLY: "Recycling",
  stage_RECYCLING: "Immediate Translation",
  stage_IMMEDIATE_TRANSLATION: "Immediate Translation",
  stage_REDACTION: "Redaction",
  stage_ENHANCEMENT: "Enhancement",
  stage_TRUST_MINING: "Trust Mining",
  stage_FINAL_REDACTION: "Final Redaction",
  stage_CORRECTION: "Correction"
}